import { render, staticRenderFns } from "./view-photo.vue?vue&type=template&id=0a87feab&scoped=true"
import script from "./view-photo.vue?vue&type=script&lang=js"
export * from "./view-photo.vue?vue&type=script&lang=js"
import style0 from "./view-photo.vue?vue&type=style&index=0&id=0a87feab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a87feab",
  null
  
)

export default component.exports